import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextField } from "@mui/material";
import { useState } from "react";

import { GeoRehandleTruckingTruckDTO } from "../../../DTOs/Geology/GeoRehandleTruckingTruckDTO";
import { ShowAllAutocomplete } from "../../../components/ShowAllAutocomplete/ShowAllAutocomplete";
import { PLANT_MODEL_LABELS } from "../../../components/ShowAllAutocomplete/showAllLabels";

type PlantModelSelectProps = {
  bucketTypeId?: number
  plantModels: GeoRehandleTruckingTruckDTO[]
  isLoading: boolean
  disabled: boolean
  onChange: (bucketTypeId: number) => unknown
  /** The row's machine is a loader, which may carry its own load instead of filling a truck. */
  allowOwnLoad?: boolean
  onOwnLoad?: () => unknown
}

const PlantModelSelect: React.FC<PlantModelSelectProps> = ({
  bucketTypeId,
  plantModels,
  isLoading,
  disabled,
  onChange,
  allowOwnLoad = false,
  onOwnLoad
}) => {
  const [isWorking, setIsWorking] = useState(false);
  const selected = plantModels.find(x => x.bucketTypeId === bucketTypeId) ?? null;
  const showsOwnLoad = allowOwnLoad && selected == null;

  return (
    <ShowAllAutocomplete
      labels={PLANT_MODEL_LABELS}
      classes={{ root: 'w-full' }}
      size="small"
      loading={isLoading || isWorking}
      disabled={isLoading || isWorking || disabled}
      disableClearable={!allowOwnLoad}
      options={plantModels}
      getOptionLabel={(option) => option.bucketType}
      value={selected}
      isOptionEqualToValue={(option, value) => option.bucketTypeId === value.bucketTypeId}
      onChange={async (_event, newValue) => {
        const save = newValue ? () => onChange(newValue.bucketTypeId) : onOwnLoad;
        if (!save) return;
        setIsWorking(true);
        await save();
        setIsWorking(false);
      }}
      renderInput={(params) => <TextField
        {...params}
        label="Plant Model"
        placeholder={showsOwnLoad ? "Own load" : undefined}
        slotProps={{
          ...params.slotProps,
          inputLabel: showsOwnLoad ? { ...params.slotProps.inputLabel, shrink: true } : params.slotProps.inputLabel,
          input: {
            ...params.slotProps.input,
            endAdornment: (
              <>
                {(isLoading || isWorking) && <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />
  );
};

export default PlantModelSelect;
